import { io, Socket } from 'socket.io-client';

export interface SocketInterface {
  socket: Socket;
  socketMessageType: 'assistant' | 'searchResult' | null;
}

class SocketConnection implements SocketInterface {
  public socket: Socket;
  public socketMessageType: SocketInterface['socketMessageType'] = null;
  public socketEndpoint = import.meta.env.VITE_KNOWZ_WEB_SOCKET_URL;
  constructor() {
    this.socket = io(this.socketEndpoint, {
      transports: ['websocket', 'polling'],
      withCredentials: true,
    });
  }
}

let socketConnection: SocketConnection | undefined;

class SocketFactory {
  public static create(): SocketConnection {
    if (!socketConnection) {
      socketConnection = new SocketConnection();
    }
    return socketConnection;
  }
}

export default SocketFactory;
